import React, { useContext, useEffect, useState } from "react";
import { MyContext } from "../../App";
import { fetchDataFromApi } from "../../utils/api";
import Button from "@mui/material/Button";
import { IoIosArrowRoundForward } from "react-icons/io";
import { Link } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import ProductItem from "../../Components/ProductItem";
import NoProductsFound from "../../Components/NoProductsFound";

const RandomCategoryProducts = () => {
  const [randomCatProducts, setRandomCatProducts] = useState([]);
  const context = useContext(MyContext);

  useEffect(() => {
    if (context?.categoryData?.length > 0) {
      const randomIndex = Math.floor(
        Math.random() * context.categoryData.length
      );

      fetchDataFromApi(
        `/api/products/catId/${context.categoryData[randomIndex]?.id}`
      )
        .then((res) => {
          setRandomCatProducts({
            catName: context.categoryData[randomIndex]?.name,
            catId: context.categoryData[randomIndex]?.id,
            products: res?.products,
          });
        })
        .catch((error) => {
          // Handle the API error
          console.error("Failed to fetch products:", error);
          setRandomCatProducts(null);
        });
    } else {
      // Handle case when categoryData is empty or undefined
      console.log("No category data available");
      setRandomCatProducts(null); // Optionally set to null or some fallback state
    }
  }, [context?.categoryData]);

  if (!randomCatProducts?.products?.length) {
    return <NoProductsFound />;
  }

  return (
    <>
      <div className="d-flex align-items-center mt-1 pr-3">
        <div className="info">
          <h3 className="mb-0 hd">{randomCatProducts?.catName}</h3>
        </div>

        <Link
          to={`/products/category/${randomCatProducts?.catId}`}
          className="ml-auto"
        >
          <Button className="viewAllBtn">
            View All <IoIosArrowRoundForward />
          </Button>
        </Link>
      </div>

      {randomCatProducts?.length === 0 ? (
        <div
          className="d-flex align-items-center justify-content-center"
          style={{ minHeight: "300px" }}
        >
          <CircularProgress />
        </div>
      ) : (
        <div className="product_row w-100 mt-2">
          {context.windowWidth > 992 ? (
            <Swiper
              slidesPerView={5}
              spaceBetween={0}
              navigation={true}
              slidesPerGroup={context.windowWidth > 992 ? 3 : 1}
              modules={[Navigation]}
              className="mySwiper"
              breakpoints={{
                300: {
                  slidesPerView: 1,
                  spaceBetween: 5,
                },
                400: {
                  slidesPerView: 2,
                  spaceBetween: 5,
                },
                600: {
                  slidesPerView: 4,
                  spaceBetween: 5,
                },
                750: {
                  slidesPerView: 5,
                  spaceBetween: 5,
                },
              }}
            >
              {Array.isArray(randomCatProducts?.products) &&
              randomCatProducts?.products?.length > 0 ? (
                randomCatProducts?.products?.slice(0)?.map((item, index) => (
                  <SwiperSlide key={index}>
                    <ProductItem item={item} />
                  </SwiperSlide>
                ))
              ) : (
                <NoProductsFound />
              )}

              <SwiperSlide style={{ opacity: 0 }}>
                <div className={`productItem`}></div>
              </SwiperSlide>
            </Swiper>
          ) : (
            <div className="productScroller">
              {Array.isArray(randomCatProducts?.products) &&
              randomCatProducts?.products?.length > 0 ? (
                randomCatProducts?.products
                  ?.slice(0)
                  ?.map((item, index) => (
                    <ProductItem item={item} key={index} />
                  ))
              ) : (
                <NoProductsFound />
              )}
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default RandomCategoryProducts;
